import {envConfig} from 'config';

export const APP_NAME = 'Eazyshow';
export const APP_LANDING_UPGRADE_URL = `${envConfig.appLandingUrl}/upgrade`;
export const APP_SUPPORT_EMAIL = 'support@eazyshow.com';